import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Paragraph } from '@frontapp/ui-kit';
import { Portal } from 'react-portal';

type AskIfAbortModalProps = {
  message: string;
  button?: string;
};

const AskIfAbortModal = NiceModal.create(
  ({ message, button = 'OK' }: AskIfAbortModalProps) => {
    const { hide, resolve, visible, remove } = useModal();

    if (!visible) {
      return null;
    }

    return (
      <Portal>
        <div className="Modal__backdrop">
          <div className="Modal__dialog">
            <Paragraph>{message}</Paragraph>
            <div className="Modal__dialog__actions">
              <Button
                onClick={() => {
                  resolve(true);
                  hide();
                }}
              >
                Cancel
              </Button>
              <div className="Modal__dialog__actions__flex" />
              <Button
                type="primary-danger"
                onClick={() => {
                  resolve(false);
                  hide();
                }}
              >
                {button}
              </Button>
            </div>
          </div>
        </div>
      </Portal>
    );
  },
);

export async function askIfAbort(message: string, button?: string) {
  const result = await NiceModal.show<boolean>(AskIfAbortModal, {
    message,
    button,
  });

  return result;
}
